<app-content-area
  [title]="title | translate"
  (emitterEventActionClick)="handleFormAreaEvent('cancel')"
>
  <app-form-area
    [formGroup]="form"
    (emitterEventActionClick)="handleFormAreaEvent($event)"
  >
    <h4> {{ 'CLIENTS_FORM.FORM.ENTERPRISE_DATA.TITLE' | translate }}</h4>
    <app-input
      type="text"
      [label]="'CLIENTS_FORM.FORM.ENTERPRISE_DATA.CNPJ' | translate"
      [placeholder]="'CLIENTS_FORM.FORM.ENTERPRISE_DATA.CNPJ_PLACEHOLDER' | translate"
      [control]="form.get('personData.document')"
      mask="cpf"
    />
    <app-input
      type="text"
      [label]="'CLIENTS_FORM.FORM.ENTERPRISE_DATA.SOCIAL_REASON' | translate"
      [placeholder]="'CLIENTS_FORM.FORM.ENTERPRISE_DATA.SOCIAL_REASON_PLACEHOLDER' | translate"
      [control]="form.get('personData.name')"
    />
    <app-input
      type="email"
      [label]="'CLIENTS_FORM.FORM.ENTERPRISE_DATA.EMAIL' | translate"
      [placeholder]="'CLIENTS_FORM.FORM.ENTERPRISE_DATA.EMAIL_PLACEHOLDER' | translate"
      [control]="form.get('personData.email')"
      (valueChange)="handleEmailChange($event)"
    />
    <div class="slide-toggle-container">
      <mat-slide-toggle
        labelPosition="before"
        [checked]="form.get('status')?.value === true"
        (change)="form.get('status')?.setValue($event.checked)"
        color="primary"
      >
        {{ 'CLIENTS_FORM.FORM.ENTERPRISE_DATA.STATUS' | translate }}
      </mat-slide-toggle>
    </div>
    <h4> {{ 'CLIENTS_FORM.FORM.ORGANIZATIONAL_STRUCTURE.TITLE' | translate }}</h4>
    <app-checkbox
      [title]="'CLIENTS_FORM.FORM.ORGANIZATIONAL_STRUCTURE.MATRIX_ENTERPRISE' | translate"
      [control]="form.get('personData.isHeadOffice')"
      [options]="matrixEnterpriseOptions"
      (valueChange)="matrixEnterpriseChange()"
    />
    <app-checkbox
      [title]="'CLIENTS_FORM.FORM.ORGANIZATIONAL_STRUCTURE.BRF' | translate"
      [control]="form.get('personData.isBrf')"
      [options]="matrixEnterpriseOptions"
      (valueChange)="sapChange()"
    />
    @if (form.get('personData.isBrf')?.value === true) {
      @if (form.get('personData.isHeadOffice')?.value === true) {
        <app-input
          type="text"
          [label]="'CLIENTS_FORM.FORM.ORGANIZATIONAL_STRUCTURE.MATRIZ_CODE' | translate"
          [placeholder]="'CLIENTS_FORM.FORM.ORGANIZATIONAL_STRUCTURE.MATRIZ_CODE_PLACEHOLDER' | translate"
          [control]="form.get('personData.sapBukrs')"
        />
      }
      @if (form.get('personData.isHeadOffice')?.value === false) {
        <app-input
          type="text"
          [label]="'CLIENTS_FORM.FORM.ORGANIZATIONAL_STRUCTURE.FILIAL_CODE' | translate"
          [placeholder]="'CLIENTS_FORM.FORM.ORGANIZATIONAL_STRUCTURE.FILIAL_CODE_PLACEHOLDER' | translate"
          [control]="form.get('personData.sapBranch')"
        />
      }
      <app-input
        type="text"
        [label]="'CLIENTS_FORM.FORM.ORGANIZATIONAL_STRUCTURE.LOGISTIC_CENTER_CODE' | translate"
        [placeholder]="'CLIENTS_FORM.FORM.ORGANIZATIONAL_STRUCTURE.LOGISTIC_CENTER_CODE_PLACEHOLDER' | translate"
        [control]="form.get('personData.sapWerks')"
      />
    }
    @if(form.get('personData.isHeadOffice')?.value === false) {
      <app-select
        label="{{ 'CLIENTS_FORM.FORM.ORGANIZATIONAL_STRUCTURE.FILIAL_ENTERPRISE_SELECT' | translate }}"
        placeholder="{{ 'CLIENTS_FORM.FORM.ORGANIZATIONAL_STRUCTURE.FILIAL_ENTERPRISE_SELECT_PLACEHOLDER' | translate }}"
        [control]="form.get('personData.headOfficeId')"
        [items]="enterpriseList"
        (searchChange)="getEnterpriseList($event)"
        filteredByEndpoint
      />
    }
    <h4> {{ 'CLIENTS_FORM.FORM.PLAN_DATA.TITLE' | translate }}</h4>
    <app-input
      type="text"
      [label]="'CLIENTS_FORM.FORM.PLAN_DATA.PDVS_QUANTITY' | translate"
      placeholder=""
      [control]="form.get('plansData.pdvQuantity')"
    />
    <app-input
      type="text"
      [label]="'CLIENTS_FORM.FORM.PLAN_DATA.MONTHLY_FEE' | translate"
      placeholder=""
      [control]="form.get('plansData.monthlyFee')"
      mask="currency"
    />
    <app-document-upload
      [id]="id"
      [label]="'CLIENTS_FORM.FORM.PLAN_DATA.UPLOAD_FILE_CONTRACT' | translate"
      [control]="form.get('plansData.contractFileUrl')"
      type="CustomerContract"
    />
    <app-input
      type="textarea"
      [label]="'CLIENTS_FORM.FORM.PLAN_DATA.OBSERVATION' | translate"
      [placeholder]="'CLIENTS_FORM.FORM.PLAN_DATA.OBSERVATION_PLACEHOLDER' | translate"
      [control]="form.get('plansData.observation')"
    />
    @if(form.get('personData.isHeadOffice')?.value === true || id) {
      <h4> {{ 'CLIENTS_FORM.FORM.PLAN_USER_ADMIN.TITLE' | translate }}</h4>
      <app-input
        type="text"
        [label]="'CLIENTS_FORM.FORM.PLAN_USER_ADMIN.USER_ADMIN' | translate"
        [placeholder]="'CLIENTS_FORM.FORM.PLAN_USER_ADMIN.USER_ADMIN_PLACEHOLDER' | translate"
        [control]="form.get('name')"
      />
      <app-input
        type="email"
        [label]="'CLIENTS_FORM.FORM.PLAN_USER_ADMIN.LOGIN' | translate"
        [placeholder]="'CLIENTS_FORM.FORM.PLAN_USER_ADMIN.LOGIN_PLACEHOLDER' | translate"
        [control]="form.get('login')"
      />
    }
  </app-form-area>
</app-content-area>
